import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function removeAccents(str: string) {
  return str
    .normalize("NFD") // Normaliza a string para decompor caracteres acentuados
    .replace(/[\u0300-\u036f]/g, ""); // Remove os caracteres de acento
}

export function removeSpecialCharacters(str: string) {
  return str.replace(/[^\w\s.]/gi, ""); // Remove tudo que não for letra, número ou espaço
}

export function replaceSpacesWithUnderscores(str: string) {
  return str.replace(/\s+/g, "_"); // Substitui todos os espaços (incluindo múltiplos) por underline
}

export function cleanString(str: string) {
  return removeSpecialCharacters(
    removeAccents(replaceSpacesWithUnderscores(str))
  );
}
